<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<section epub:type="dedication" role="doc-dedication">
<p class="DED" id="ded"><span aria-label="5" id="pg_5" role="doc-pagebreak"><i>My thanks go out to David Weber, Walter John Williams, Marko Kloos, and James S. A. Corey (both of them) for showing me how mil-spec sci-fi should be done and lighting a fusion torch under my ass to do it.</i></span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?f162385a